import React, { useMemo } from 'react';

import PropTypes from 'prop-types';
import { Branding as GluBranding } from '@glu/interactive-styleguide';
import { createUseStyles } from '@glu/theming';
import styles from './Branding.styles';

const useStyles = createUseStyles(styles);

const Branding = ({ createEditableParts }) => {
  const classes = useStyles();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const parts = useMemo(() => createEditableParts({ classes }), []);

  return <GluBranding editableParts={parts} classes={classes} />;
};

Branding.propTypes = {
  createEditableParts: PropTypes.func.isRequired
};

export default Branding;
